import { SPLITTER } from './constants';
const replacerPlusAndAmpersandForValidQueryString = str => str.replaceAll(", ", SPLITTER).replaceAll(" ", "+").replaceAll("&", "%26");
export { replacerPlusAndAmpersandForValidQueryString };